import $http from '../http'
import { baseUrl } from '../url'

const BASEURL = baseUrl.primary + '/v1'
const BASEURL_DEV = BASEURL + '/Salary'

const salary = {
  // BaseOnBasicsAdd(data) {
  //   return $http({
  //     method: 'post',
  //     url: `${BASEURL_DEV}/SalaryHeaderSetMatch/BaseOnBasicsAdd`,
  //     data
  //   })
  // },
  ReplacePayState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/ReplacePayState`,
      data
    })
  },
  CheckAndRefult (params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrantVoucher/CheckAndRefult`,
      params
    })
  },
  RefundEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/Refund/Edit`,
      data
    })
  },
  RefundPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/Refund/Page`,
      params
    })
  },
  SalaryGrantVoucherList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrantVoucher/List`,
      params
    })
  },
  SalaryGrantVoucherEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrantVoucher/Edit`,
      data
    })
  },
  WeChatReplacePayPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrant/WeChatReplacePayPage`,
      params
    })
  },
  SalaryHeaderMainEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderMain/Edit`,
      data,
    })
  },
  SalaryHeaderMainDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderMain/Delete`,
      data,
    })
  },
  WechatTransferSchemeSupplementLogList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferSchemeSupplementLog/List`,
      params,
    })
  },
  AnewPush(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/AnewPush`,
      data,
    })
  },
  RefreshPushState(params) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/RefreshPushState`,
      params,
    })
  },
  ClearInventory(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/ClearInventory`,
      data,
    })
  },
  WechatTransferSchemeAdjustScheme(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferScheme/AdjustScheme`,
      data,
    })
  },
  WechatTransferSchemeDetailList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/List`,
      params,
    })
  },
  CheckWechatPayState(params) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/CheckWechatPayState`,
      params,
    })
  },
  GetVierificationCode(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/GetVierificationCode`,
      params,
    })
  },
  WechatPaySendSmsCode(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/WechatPaySendSmsCode`,
      data,
    })
  },
  WechatPayAgain(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferDefeated/WechatPayAgain`,
      data,
    })
  },
  BatchPerfectInfomation(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrantDetail/BatchPerfectInfomation`,
      data,
    })
  },
  CreateDefeatedTransferVoucher(data) {
    return $http({
      responseType: 'blob',
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferDefeated/CreateDefeatedTransferVoucher`,
      data,
    })
  },
  WechatTransferSchemeDetailPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/Page`,
      params,
    })
  },
  WechatTransferDefeatedList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferDefeated/List`,
      params,
    })
  },
  GoToWechatTransfer(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/GoToWechatTransfer`,
      data,
    })
  },
  CreateInventory(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/WechatTransferSchemeDetail/CreateInventory`,
      data
    })
  },
  // 发放方案
  GetSchemeList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/WechatTransferScheme/GetSchemeList`,
      params
    })
  },
  SalaryEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryEdit`,
      data
    })
  },
  GetStandardHeader(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeader/GetStandardHeader`,
      params
    })
  },
  SalaryAdd(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryAdd`,
      data
    })
  },
  SalaryIntroduceUserData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryOriginalData/SalaryIntroduceUserData`,
      data
    })
  },
  SalarySheetAdd(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryOriginalData/SalarySheetAdd`,
      data
    })
  },
  DefaultSalaryHeader(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeader/DefaultSalaryHeader`,
      params
    })
  },
  CheckSalatyInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/CheckSalatyInfo`,
      data
    })
  },
  SmartMatchSalaryCalculate(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SmartMatchSalaryCalculate`,
      data
    })
  },
  FormattingHeaderMatch(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/FormattingHeaderMatch`,
      params
    })
  },
  SaveDirectGenerateFormattingHeaderMatch(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SaveDirectGenerateFormattingHeaderMatch`,
      data
    })
  },
  DirectGenerateFormattingHeaderMatch(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/DirectGenerateFormattingHeaderMatch`,
      params
    })
  },
  UpdateCalculateState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/UpdateCalculateState`,
      data
    })
  },
  FormatterSalaryData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/FormatterSalaryData`,
      data
    })
  },
  SalaryGrantDetailCheckDetailInfo(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrantDetail/CheckDetailInfo`,
      params
    })
  },
  SalarSalaryDetailPerfectData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryDetail/PerfectData`,
      data
    })
  },
  ReleaseSalarySheet(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/ReleaseSalarySheet`,
      data
    })
  },
  GetSalaryComparisonInfoList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryDetail/GetSalaryComparisonInfoList`,
      params
    })
  },
  OneKeyGenerateSalaryHeader(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderSetMatch/OneKeyGenerateSalaryHeader`,
      data
    })
  },
  SalaryHeaderSetMatchList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeaderSetMatch/List`,
      params
    })
  },
  BaseOnBasicsAdd(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderSetMatch/BaseOnBasicsAdd`,
      data
    })
  },
  DataFormattingToStandardSalary(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/DataFormattingToStandardSalary`,
      data
    })
  },
  UpdateUserApplyParent(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/UpdateUserApplyParent`,
      data
    })
  },
  SalaryOriginalDataBatchEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryOriginalData/BatchEdit`,
      data
    })
  },
  SalaryOriginalDataDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryOriginalData/Delete`,
      data
    })
  },
  TransferAccountsFinish(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/TransferAccountsFinish`,
      data
    })
  },
  CreateSalartSheet(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/CreateSalartSheet`,
      data
    })
  },
  CreateTransferVouchert(data) {
    return $http({
      responseType: 'blob',
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/CreateTransferVouchert`,
      data
    })
  },
  UpdatePayUnit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/UpdatePayUnit`,
      data
    })
  },
  UpdateProjectName(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/UpdateProjectName`,
      data
    })
  },
  SalaryGrantPayFinish(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/PayFinish`,
      data
    })
  },
  UpdateEmployingUnit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/UpdateEmployingUnit`,
      data
    })
  },
  SalaryOriginalDataEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryOriginalData/Edit`,
      data
    })
  },
  RollBackCalculateData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/RollBackCalculateData`,
      data
    })
  },
  SubstitutePayPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SubstitutePayPage`,
      params
    })
  },
  SubstitutePay(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SubstitutePay`,
      data
    })
  },
  OrignalDataCalculate(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/OrignalDataCalculate`,
      params
    })
  },

  SalaryOriginalCalculateInfoPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryOriginalCalculateInfoPage`,
      params
    })
  },
  OriginalDatePage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/OriginalDatePage`,
      params
    })
  },
  ImportManHourInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/ImportManHourInfo`,
      data
    })
  },
  SalaryDetailBatchDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryDetail/BatchDelete`,
      data
    })
  },
  SalaryCalculateBatchDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/BatchDelete`,
      data
    })
  },
  SalaryHeaderList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeader/List`,
      params
    })
  },
  SalaryHeaderDelete(params) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeader/Delete`,
      params
    })
  },
  SalaryHeaderSetList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeaderSet/List`,
      params
    })
  },
  SalaryHeaderEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SalaryHeader/Edit`,
      data
    })
  },
  SalaryCalculateFileImport(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SalaryCalculate/FileImport`,
      data
    })
  },
  SalaryCalculatePage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/SalaryCalculate/Page`,
      params
    })
  },
  SalaryCalculateDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SalaryCalculate/Delete`,
      data
    })
  },
  SalaryDetailPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryDetail/Page`,
      params
    })
  },
  SalaryGrantPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrant/Page`,
      params
    })
  },
  salaryCalculationDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryDetail/Page`,
      params
    })
  },
  SalaryCalculateAffirm(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/Affirm`,
      data
    })
  },
  SalaryDetailPayrollComputation(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryDetail/PayrollComputation`,
      data
    })
  },
  SalaryDetailDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryDetail/Delete`,
      data
    })
  },
  SalaryDetailEdit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryDetail/Edit`,
      data
    })
  },
  SalaryGrantImportCalculateData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/ImportCalculateData`,
      data
    })
  },
  SalaryGrantDetailPage(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrantDetail/Page`,
      params
    })
  },
  SalaryGrantSubmitAudit() {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/SubmitAudit`,
      params
    })
  },
  SalaryHeaderMyList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeader/MyList`,
      params
    })
  },
  SalaryGrantSubmitAudit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/SalaryGrant/SubmitAudit`,
      data
    })
  },
  SalaryAuditList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryAudit/List`,
      params
    })
  },
  SalaryGrantAudit(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/Audit`,
      data
    })
  },
  SalaryHeaderMainEditSalaryInfo(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderMain/EditSalaryInfo`,
      data
    })
  },
  SalaryHeaderMainList() {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryHeaderMain/List`
    })
  },
  SalaryHeaderMainSetUseState(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryHeaderMain/SetUseState`,
      data
    })
  },
  SalaryGrantDelete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryGrant/Delete`,
      data
    })
  },
  SalaryGrantDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrant/Detail`,
      params
    })
  },
  SalaryGrantDetailStatisticsData(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryGrant/PayStatistics`,
      params
    })
  },
  SalaryCalculateMatchedData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/MatchedData`,
      data
    })
  },
  SalaryCalculateMainDetail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryCalculate/MainDetail`,
      params
    })
  },
  GenerateSalarySheet(params) {
    return $http({
      method: 'get',
      url: `${BASEURL_DEV}/SalaryCalculate/GenerateSalarySheet`,
      params
    })
  },
  SalaryCalculateSendBack(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/SalaryCalculate/SendBack`,
      data
    })
  }
}

export default salary
